import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class QuestionTypes {
  static list: IActionType = new ActionType('QUESTION/LIST');
  static listChatQuestions: IActionType = new ActionType('QUESTION/LIST_CHAT');
  static answerQuestion: IActionType = new ActionType('QUESTION/ANSWER_QUESTION');
  static updateQuestion: IActionType = new ActionType('QUESTION/UPDATE_QUESTION');
}

export default QuestionTypes;
